function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   * ACE-editor related utility functions
   */
  factory('AceUtils', [function () {
    return {
      /**
       * Set editor error annotations based on a propertyPath and a supplied message
       *
       * @param propertyPath {Array} - An array of Strings or Objects.
       *        Object may be structured as follows:
       *        {
       *            nth: Number - The nth instance of <match> to find
       *            match: String - The string match to search for
       *        }
       * @param message
       */
      setEditorError: function setEditorError(editor, propertyPath, message) {
        // Ensure we have an array, even if one element
        propertyPath = _toConsumableArray(propertyPath);
        var pos;
        propertyPath.forEach(function (p) {
          if (p.nth) {
            // Check for the nth match of p.match
            for (var i = 0; i < p.nth; i++) {
              pos = editor.find(p.match);
            }
          } else {
            pos = editor.find(p);
          }
        });
        if (!pos) {
          return;
        }
        var editorError = [{
          row: pos.start.row,
          column: pos.start.column,
          text: message,
          type: "error"
        }];
        editor.getSession().setAnnotations(editorError);
        return editorError;
      }
    };
  }]);
})();
